import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { useHistory } from 'react-router-dom';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Dialog,
  Slide,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { format } from 'date-fns';
import ExhibitorsFilters from './ExhibitorsFilters';
import ExhibitorsList from './ExhibitorsList';
import { FilterContext } from 'context/FilterContextProvider';
import {
  backHomeLink,
  charactersCount,
  defaultSearchYear,
  isQueryFiltersActive,
} from 'utils/constants';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNetwork } from 'services/network';
import { LoaderCountContext } from 'context/LoaderV5';
import { useDebounce } from 'utils/hooks';
import {
  AlignedPageContainer,
  InsidePageContainer,
  RedLinkButton,
  WhitePageContainer,
  createFiltersFormParams,
} from '../common';
import { RegisterSection } from '../common/Dialog';
import { PageTabs, useBookmarkStore } from 'pages/exhibitor/exhibitorBookmarks';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Biennali = ({ locale, loggedUser }) => {
  const intl = useIntl();
  const i18n = translations.ExhibitorsV2(intl).Filters;
  const i18nLegacy = translations.ExhibitorsList(intl);
  const theme = useTheme();
  const history = useHistory();
  const is1024Up = useMediaQuery(theme.breakpoints.up(1024));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const { filter, yearSelected, setYearSelected } = useContext(FilterContext);
  const network = useNetwork();
  const { setLoaderActive } = useContext(LoaderCountContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  //States
  const [queryParams, setQueryParams] = useState();
  const [currentFilters, setCurrentFilters] = useState();
  const [hasParam, setHasParam] = useState(true);
  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
  const [isRegisterDialogOpen, setIsRegisterDialogOpen] = useState(false);
  const [registerCtx, setRegisterCtx] = useState('');
  const [elevationMobileBottom, setElevationMobileBottom] = useState(3);
  const debouncedSearchUrl = useDebounce(queryParams, 500);
  //Contants
  const pageSize = 12;
  // const LOGIN_URL = `${backHomeLink}/${locale}/saml_login?lang=${locale}`;
  //Effects
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const brandId = params.get('salesforce_id');
    const fetchBrand = async () => await handleParamExhibitor(brandId);
    if (brandId && filter) fetchBrand();
    const historyState = history.location.state;
    if (filter && !brandId) {
      let queryHistoryState = null;
      if (isQueryFiltersActive) {
        const url = new URL(window.location.href);
        const queryFilters = createFiltersFormParams({ url });
        const state = {
          oldFilters: queryFilters,
        };
        history.replace('/', state);
        queryHistoryState = history.location.state;
      }
      handleFilterChange(
        isQueryFiltersActive
          ? queryHistoryState?.oldFilters
          : historyState?.oldFilters
      );
    }
  }, [filter]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const brandId = params.get('salesforce_id');
    setHasParam(!!brandId);
  }, []);

  const Header = () => (
    <>
      <Typography
        variant={'xxl'}
        textAlign={'center'}
        fontFamily={'Parmisan-Regular'}
        component={'h1'}
        // fontFamily={'Suisse-Intl'}
      >
        {i18nLegacy.page.titleBiennali}
      </Typography>
      <div>
        <Typography variant="body1" textAlign={'center'}>
          {i18nLegacy.page.subtitleDescriptionBiennali}
        </Typography>
      </div>
    </>
  );

  const handleParamExhibitor = async (brandId) => {
    showLoader();
    const e = await network.exhibitorGet(brandId);
    const parsed = !e.error
      ? {
          name: e.nomeEspositore,
          provincia: e.provinciaSigla,
          indirizzo: e.indirizzo,
          comune: e.comune,
          email: e.email,
          cap: e.cap,
          appuntamenti: e.appuntamenti || false,
          prenotazioneAppuntamenti: e.prenotazioneAppuntamenti || false,
          emailDigitale: e.emailDigitale || e.email,
          percorsiTematici: e.percorsiTematici,
          categorie_en: e.categorieE,
          categorie_it: e.categorieI,
          prodotti_en: e.prodottiE,
          prodotti_it: e.prodottiI,
          phone: e.telefono,
          fax: e.fax,
          website: e.sitoInternet,
          hall: e.hall,
          stand: e.stand,
          erpid: e.erpId,
          nation: filter?.nations.find(
            (n) => n.isoCode === e.nazioneIso3AlphaCode
          )?.label,
          event:
            e.evento
              ?.split('|')
              .map(
                (evento) =>
                  filter?.exhibitions.find((ex) => ex.code === evento)?.label ||
                  i18nLegacy.page.notAvailable
              )
              .join(', ') || '',
          salesforceId: e.accountId,
          linkedAccountId: e.linkedAccountId,
          // isLiked: false,
        }
      : null;
    // TODO add api call to GET user favourites
    // const fetchedLikedExhibitors = FAKED_LIKE;
    if (parsed && e && !e.error) {
      const historyState = history.location.state;
      const state = {
        ...historyState,
        exhibitor: {
          ...parsed,
        },
        oldFilters: currentFilters,
      };
      history.push(`/detail?salesforce_id=${brandId}`, state);
    } else {
      window.location.href = `${backHomeLink}/${locale}/exhibitors`;
    }
    hideLoader();
  };

  const navigateExhibitorDetail = (exhibitor) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    const historyState = history.location.state;
    const state = {
      ...historyState,
      exhibitor: {
        ...exhibitor,
      },
      oldFilters: currentFilters,
    };
    history.push('/detail', state);
  };

  const handleFilterChange = (activeFilters) => {
    const f0 = `anno=${+defaultSearchYear - 1}`;
    let filterUrlQuery = `${f0}`;
    if (activeFilters && Object.keys(activeFilters)?.length) {
      const containsEncodedComponent = (filter) =>
        decodeURI(filter !== decodeURIComponent(filter));

      const f1 = `${
        activeFilters.search && activeFilters.search.length >= charactersCount
          ? containsEncodedComponent(activeFilters.search)
            ? `&nome=${encodeURIComponent(
                decodeURIComponent(activeFilters.search)
              )}`
            : `&nome=${encodeURIComponent(activeFilters.search)}`
          : ''
      }`;
      const f2 = `${
        //!activeFilters.search &&
        activeFilters.alphabet
          ? `&iniziale=${encodeURIComponent(activeFilters.alphabet)}`
          : ''
      }`;
      const f3 = `${
        activeFilters.nation ? `&nazionalita=${activeFilters.nation}` : ''
      }`;
      const f4 = `${
        activeFilters.exhibitors && activeFilters.exhibitors.length > 0
          ? `&evento=${activeFilters.exhibitors.join('|')}`
          : ''
      }`;
      const f5 = `${activeFilters.hall ? `&hall=${activeFilters.hall}` : ''}`;
      const f6 = `${
        activeFilters.category ? `&categoria=${activeFilters.category}` : ''
      }`;
      const f7 = `${
        activeFilters.product ? `&prodotto=${activeFilters.product}` : ''
      }`;
      const f8 = `${activeFilters.visits?.length ? `&appuntamenti=true` : ''}`;
      const f9 = `${
        activeFilters.itinerary
          ? `&percorsiTematici=${activeFilters.itinerary}`
          : ''
      }`;

      filterUrlQuery = `${filterUrlQuery}${f1}${f2}${f3}${f4}${f5}${f6}${f7}${f8}${f9}`;
    }
    const f10 = `&pageSize=${pageSize}`;
    const f11 = isQueryFiltersActive
      ? `&pageNumber=${activeFilters?.pageNumber || '1'}`
      : '';
    filterUrlQuery = `${filterUrlQuery}${f10}${f11}`;
    setCurrentFilters(activeFilters);
    setQueryParams(filterUrlQuery);
  };
  const handleYearChange = (year) => {
    const state = {
      oldFilters: {},
    };
    history.replace('/', state);
    // FORCE STORE TO RESET IF YEAR FILTER CHANGE
    useBookmarkStore.setState({
      exhibitorsManage: [],
      folders: [],
      selectedExhibitors: [],
      isSavingToFolder: true,
      currentStoreTab: PageTabs.EXHIBITORS,
      isEditing: false,
      cardsToManage: [],
      selectedFolder: {},
      currentFolderOnView: null,
      alertData: null,
      loggedUserId: '',
    });
    setYearSelected(year);
  };

  const openFilters = () => {
    handleClickOpen();
  };

  const handleClickOpen = () => {
    setIsFilterDialogOpen(true);
  };

  const handleClose = (filters) => {
    const state = {
      oldFilters: filters,
    };
    history.replace('/', state);
    setIsFilterDialogOpen(false);
  };

  const handleOpenRegisterDialog = (ctx) => {
    setRegisterCtx(ctx);
    setIsRegisterDialogOpen(true);
  };

  return (
    !hasParam && (
      <div>
        <>
          <InsidePageContainer>
            <WhitePageContainer>
              <Header />
            </WhitePageContainer>
          </InsidePageContainer>
          <AlignedPageContainer>
            <InsidePageContainer
              flexDirection={is1024Up ? 'row' : 'column'}
              gap={is1024Up ? '40px' : '30px'}
            >
              {is1024Up ? (
                <ExhibitorsFilters
                  locale={locale}
                  onChange={handleFilterChange}
                  onYearChange={handleYearChange}
                  filter={filter}
                  oldFilters={history.location.state?.oldFilters}
                  yearSelected={yearSelected}
                  isBiennali={true}
                />
              ) : (
                <Stack
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'flex-start'}
                  width={'100%'}
                >
                  <RedLinkButton
                    msg={i18n.filter}
                    onClick={() => openFilters()}
                    variant={'link2'}
                    leftIcon={<TuneIcon fontSize="small" color="primary" />}
                  />
                </Stack>
              )}
              <ExhibitorsList
                queryParams={debouncedSearchUrl}
                nations={filter?.nations || []}
                exhibitions={filter?.exhibitions || []}
                openRegisterDialog={handleOpenRegisterDialog}
                locale={locale}
                loggedUser={loggedUser}
                navigateExhibitorDetail={navigateExhibitorDetail}
                isBiennali={true}
              />
            </InsidePageContainer>
          </AlignedPageContainer>
          <Dialog
            fullScreen
            open={isFilterDialogOpen}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              onScroll: (e) => {
                const bottom =
                  e.target.scrollHeight - e.target.scrollTop ===
                  e.target.clientHeight;
                if (bottom) {
                  setElevationMobileBottom(0);
                } else {
                  setElevationMobileBottom(3);
                }
              },
            }}
          >
            <ExhibitorsFilters
              locale={locale}
              onChange={handleFilterChange}
              onYearChange={handleYearChange}
              filter={filter}
              oldFilters={history.location.state?.oldFilters}
              yearSelected={yearSelected}
              handleMobileFiltersClose={handleClose}
              elevationMobileBottom={elevationMobileBottom}
            />
          </Dialog>
          <Dialog
            open={isRegisterDialogOpen}
            onClose={() => {
              setRegisterCtx('');
              setIsRegisterDialogOpen(false);
            }}
            PaperProps={{
              style: {
                padding: 40,
                maxWidth: 720,
                borderRadius: '12px',
              },
            }}
          >
            <RegisterSection
              isSmDown={isSmDown}
              onClose={() => {
                setRegisterCtx('');
                setIsRegisterDialogOpen(false);
              }}
              locale={locale}
              ctx={registerCtx}
            />
          </Dialog>
        </>
      </div>
    )
  );
};
export default Biennali;
